import { Navigate } from "react-router-dom";
import { useAdminPermissions } from "@hooks/useAdminPermissions";
import { PERMISSION_ERROR_PATH } from "@components/PermissionGuard";

// Sends the user to the first admin section they can access, in menu order.
// Falls back to the permission-error page only when no section is permitted.
export const AdminLandingRedirect = () => {
    const {
        canViewDashboard,
        canViewMonitoring,
        canViewDoctype,
        canViewCategory,
        canViewProvider,
    } = useAdminPermissions();

    const target = [
        { path: "dashboard", allowed: canViewDashboard },
        { path: "monitoring", allowed: canViewMonitoring },
        { path: "doctypes", allowed: canViewDoctype },
        { path: "categories", allowed: canViewCategory },
        { path: "providers", allowed: canViewProvider },
    ].find((section) => section.allowed);

    return <Navigate to={target?.path ?? PERMISSION_ERROR_PATH} replace />;
};
